export default __webpack_public_path__ + "Baichuan22dc729.png";